export default __webpack_public_path__ + "static/media/paginate-filter-picture.79de8acd.svg";